import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ISiteUserInfo } from '@pnp/sp/site-users/types';
import { Subscription } from 'rxjs';
import { CurrentUserService } from 'src/app/services/current-user.service';
import { EventBrokerService } from 'src/app/services/event-broker.service';
import { SideBarService } from 'src/app/services/side-bar.service';
import { applySort, distinct, distinctCount, getValue, iterableMap, newId, SortDirection, sort } from 'src/app/services/utils';
import { FilterProperty, ListFilterService, PropertyFilterComponent, Option, StringDataBag, FilterMode, FilterPropertyChanged } from '../list-filter-service';



@Component({
  selector: 'app-string-filter',
  templateUrl: './string-filter.component.html'
})
export class StringFilterComponent implements PropertyFilterComponent, OnInit, OnDestroy {
  private visibleOptionCount = 5;
  areAllOptionsVisible = false;

  private _mode: 'List' | 'Search' = 'List';
  get mode() {
    return this._mode;
  }
  @Input()
  set mode(value: 'List' | 'Search') {
    if (!value || value.length <= 0 || value === this._mode) return;
    this._mode = value;
    this.load();
  }

  @Output() filterChanged = new EventEmitter();

  allOptionCount: number;
  listfilterSeesionObj:any=[]

  private _property: FilterProperty;
  get property(): FilterProperty {
    return this._property;
  }
  @Input()
  set property(value: FilterProperty) {
    if (!value || value.Path.length <= 0 || value === this._property) return;
    this._property = value;
    this.propertyPath = value && value.Path && value.Path.split('.');
    this.load();
  }

  private _filterMode: FilterMode;
  get filterMode(): FilterMode {
    return this._filterMode;
  }
  @Input()
  set filterMode(value: FilterMode) {
    if (!value || value.length <= 0 || value === this._filterMode) return;
    this._filterMode = value;
    this.load();
  }
  private _filterService: ListFilterService;
  get filterService(): ListFilterService {
    return this._filterService;
  }
  @Input()
  set filterService(value: ListFilterService) {
    if (!value || value === this._filterService) return;
    this._filterService = value;
    this.load();
  }

  visibleOptions: Option[] = [];
  options: Option[] = [];
  private propertyPath: string[]
  private items: any[];

  meId = newId();
  isMeSelected = false;

  get isSeeAllVisible(): boolean {
    if (this._property.Type === 'People') {
      return this.filterMode === 'MultipleProperties' &&
        this.allOptionCount > this.visibleOptionCount - 1 && !this.areAllOptionsVisible;
    }
    return this.filterMode === 'MultipleProperties' &&
      this.allOptionCount > this.visibleOptionCount && !this.areAllOptionsVisible;

    // to test see all on people type
    /*
        return this.filterMode === 'MultipleProperties' &&
      (this.allOptionCount > visibleOptionCount || this._property?.Type === 'People');
    */
  }

  get isMeVisible(): boolean {
    return this._property && this._property.Type === 'People';
  }

  get isSideBar(): boolean {
    return this._filterMode === 'FilterBy' || this._filterMode === 'SeeAll';
  }

  private filterPropertyChangedSubscription: Subscription;
  private filterClearedSubscription: Subscription;
  private currentUser: ISiteUserInfo;

  constructor(
    private eventBroker: EventBrokerService,
    currentUserService: CurrentUserService,
    public sidebar: SideBarService) {
    this.filterPropertyChangedSubscription = this.eventBroker.subscribe(
      'FilterPropertyChanged', this.filterPropertyChangedHandler);
    currentUserService.get().then(user => {
      this.currentUser = user;
    });
  }

  ngOnDestroy() {
    console.log("string filter destroyed");
    if (this.filterPropertyChangedSubscription) this.filterPropertyChangedSubscription.unsubscribe();
    if (this.filterClearedSubscription) this.filterClearedSubscription.unsubscribe();
  }

  ngOnInit() {
    console.log("string filter initialized");
    this.filterClearedSubscription = this.eventBroker.subscribe(
      'FilterCleared', this.filterClearedHandler
    );
  }

  private filterClearedHandler = (filterService: ListFilterService) => {
    console.log("string filter filterClearedHandler");
    if (filterService !== this.filterService) return;
    this.load();
  }

  private filterPropertyChangedHandler = (e: FilterPropertyChanged) => {
    console.log("string filter filterPropertyChangedHandler");
    if (e.sender === this || this._property !== e.property) return;
    this.load();
  }

  // private getSelectedOptionCount() {
  //   let count = 0;
  //   for (const op of this.options) {
  //     if (op.IsChecked) count++;
  //   }
  //   if (this.isMeSelected) count++;
  //   return count;
  // }

  get selectedOptionCount() {
    let count = 0;
    for (const op of this.options) {
      if (op.IsChecked) count++;
    }
    if (this.isMeSelected) count++;
    return count;
  }

  get isFooterVisible(): boolean {
    return this.filterMode === 'FilterBy' || this.filterMode === 'SeeAll';
  }

  // get title() {
  //   if (!this._property) return undefined;
  //   const selectedOptionCount = this.getSelectedOptionCount();
  //   if (this.filterMode === 'MultipleProperties') {
  //     if (selectedOptionCount) {
  //       return `${this.property.DisplayName} (${selectedOptionCount})`;
  //     }
  //     else {
  //       return this.property.DisplayName;
  //     }
  //   }
  //   else {
  //     if (selectedOptionCount) {
  //       return `Filter by '${this.property.DisplayName}' (${selectedOptionCount})`;
  //     }
  //     else {
  //       return `Filter by '${this.property.DisplayName}'`;
  //     }
  //   }
  // }

  get title() {
    if (!this._property) return undefined;

    if (this.filterMode === 'MultipleProperties') {
      return this.property.DisplayName;
    }
    else {
      return `Filter by '${this.property.DisplayName}'`;
    }
  }

  private getItems(): any[] {
    if (this.filterMode === 'FilterBy') {
      return this.filterService.getFiltedItems(this.property)
    }
    return this.filterService.items;
  }

  private getAllOptions(): Option[] {
    const allValues = iterableMap(this.items, item => getValue(item, this.propertyPath, false) as (string | number));
    if ((this._property.Type === 'string' || this._property.Type === 'People') && this.mode === 'List') {
      const allDistinctCountValues = distinctCount(allValues as Iterable<string>, 'Descending');
      const returnList = allDistinctCountValues.map(countItem => {
        if (countItem.item) {
          return {
            DisplayName: countItem.item,
            Value: countItem.item.toLowerCase(),
            IsChecked: false,
            Id: newId()
          };
        }
        return {
          DisplayName: '(no metadata tag)',
          Value: null,
          IsChecked: false,
          Id: newId()
        };
      });
      sort(returnList, 'Value', SortDirection.Ascending);	
      return returnList;
    }
    else {
      const allDistinctValues = distinct(allValues) as (number | string)[];
      const returnList = allDistinctValues.map(x => {
        if (x === null) {
          return {
            DisplayName: '(no metadata tag)',
            Value: null,
            IsChecked: false,
            Id: newId()
          };
        }
        return {
          DisplayName: typeof x === 'number' ? x.toString(10) : x,
          Value: typeof x === 'number' ? x : x.toLowerCase(),
          IsChecked: false,
          Id: newId()
        };
      });
      sort(returnList, 'Value', SortDirection.Ascending);	
      return returnList;
    }
  }

  load(): void {
    if (!this._filterService || !this._property || !this._filterMode) {
      this.items = [];
      this.options = [];
      this.visibleOptions = [];
      return;
    }
    this.items = this.getItems();
    const allOptions = this.getAllOptions();
    this.allOptionCount = allOptions.length;
    const allOptionByValue = new Map<string | number, Option>();
    for (const option of allOptions) allOptionByValue.set(option.Value as string, option);
    const dataBag = this.property.DataBag as StringDataBag;
    for (const selectedOption of dataBag.SelectedOptions) {
      const op = allOptionByValue.get(selectedOption.Value as string);
      if (op) op.IsChecked = true;
    }
    if (this._property.Type === 'People') {
      this.isMeSelected = !!dataBag.IsMeSelected;
      dataBag.MeValue = this.currentUser && this.currentUser.Title;
    }
    switch (this.filterMode) {
      case 'MultipleProperties':
        this.setMultiplePropertiesOptions(allOptions, allOptionByValue);
        break;
      case 'FilterBy':
        this.setFilterByOptions(allOptions, allOptionByValue);
        break;
      case 'SeeAll':
        this.setSeeAllOptions(allOptions);
    }
  }

  private getOptionsWithNewIds(options: Option[]): Option[] {
    const result: Option[] = [];
    options.forEach(x => {
      const op = Object.assign({}, x);
      op.Id = newId();
      result.push(op);
    });
    return result;
  }

  private setSeeAllOptions(allOptions: Option[]) {
    const dataBag = this.property.DataBag as StringDataBag;
    const preferredOptions = this.getOptionsWithNewIds(dataBag.SelectedOptions
      .concat(dataBag.SelectedOptionsHistory));
    const nonPreferedOptions = allOptions.filter(
      op => preferredOptions.findIndex(po => op.Value === po.Value) < 0);
    this.options = preferredOptions.concat(nonPreferedOptions);
    this.visibleOptions = this.options;
  }

  private setFilterByOptions(allOptions: Option[], allOptionByValue: Map<string | number, Option>) {
    const dataBag = this.property.DataBag as StringDataBag;
    const preferredOptions = this.getOptionsWithNewIds(dataBag.SelectedOptions
      .concat(dataBag.SelectedOptionsHistory
        .filter(oph => allOptionByValue.has(oph.Value as string))));
    const nonPreferedOptions = allOptions.filter(
      op => preferredOptions.findIndex(po => op.Value === po.Value) < 0);
    this.options = preferredOptions.concat(nonPreferedOptions);
    this.visibleOptions = this.options;
  }

  private setMultiplePropertiesOptions(allOptions: Option[], allOptionByValue: Map<string | number, Option>) {
    const dataBag = this.property.DataBag as StringDataBag;
    let options: Option[];
    if (this.mode === 'List') {
      const preferredOptions = this.getOptionsWithNewIds(dataBag.SelectedOptions
        .concat(dataBag.SelectedOptionsHistory));
      options = preferredOptions.concat(allOptions.slice(0, this.visibleOptionCount));
      let remainingPreferredOptionCount = preferredOptions.length;
      let preferredOptionIndex = 0;
      while (preferredOptionIndex < remainingPreferredOptionCount) {
        const preferredOption = options[preferredOptionIndex];
        // buscar la opción en la zona visible
        const option = options.find((op, index) =>
          index > preferredOptionIndex && index <= this.visibleOptionCount && op.Value === preferredOption.Value);
        if (option) {
          options.splice(preferredOptionIndex, 1);
          remainingPreferredOptionCount--;
          preferredOptionIndex = 0;
        }
        else {
          preferredOptionIndex++;
        }
      }
    }
    else {
      if (dataBag.SelectedOptions.length === 0) {
        options = allOptions;
      }
      else {
        const remainingSelectedOptions = dataBag.SelectedOptions.filter(x => !allOptionByValue.has(x.Value as (string | number)));
        if (remainingSelectedOptions.length > 0) {
          options = allOptions.concat(this.getOptionsWithNewIds(remainingSelectedOptions));
          applySort(options, [{ direction: SortDirection.Ascending, propertyPath: 'Value' }]);
        }
        else {
          options = allOptions;
        }
      }
    }
    this.options = options;
    if (this._property.Type === 'People') {
      this.visibleOptions = this.areAllOptionsVisible ? options : options.slice(0, this.visibleOptionCount - 1);
    }
    else {
      this.visibleOptions = this.areAllOptionsVisible ? options : options.slice(0, this.visibleOptionCount);
    }
  }


  private setDescriptionAndTitle() {
    setTimeout(() => {
      const bag = this.property.DataBag as StringDataBag;
      if (bag.IsMeSelected || bag.SelectedOptions && bag.SelectedOptions.length > 0) {
        let selectedDisplayNames: string[] = [];
        if (bag.IsMeSelected) selectedDisplayNames.push('[Me]');
        if (bag.SelectedOptions && bag.SelectedOptions.length > 0) {
          selectedDisplayNames = selectedDisplayNames.concat(bag.SelectedOptions.map(x => x.DisplayName));
        }
        this.property.Description = `Filtered by ${selectedDisplayNames.join('; ')}`;
        this.property.Title = `Filter by (${selectedDisplayNames.length})`;
      }
      else {
        this.property.Description = undefined;
        this.property.Title = 'Filter by';
      }
    }, 0);
  }

  checkboxChanged(option: Option): void {
    if (this.filterMode === 'MultipleProperties') {
      ListFilterService.updateOption(this._property, option)
      this.setDescriptionAndTitle();
      this.filterChanged.emit();
    }
  }

  meCheckboxChanged(): void {
    if (this.filterMode === 'MultipleProperties') {
      const bag = this.property.DataBag as StringDataBag;
      bag.IsMeSelected = this.isMeSelected;
      bag.MeValue = this.currentUser?.Title;
      this.setDescriptionAndTitle();
      this.filterChanged.emit();
    }
  }


  seeAll() {
    if (this.mode == 'List') this.eventBroker.publish('SeeAll', this.property);
    else {
      this.areAllOptionsVisible = true;
      this.visibleOptions = this.options;
    }
  }

  seeLess() {
    this.areAllOptionsVisible = false;
    this.visibleOptions = this.options.slice(0, this.visibleOptionCount);
  }

  apply(): void {
    if (this._property.Type === 'People') {
      const bag = this._property.DataBag as StringDataBag;
      bag.IsMeSelected = this.isMeSelected;
      bag.MeValue = this.currentUser && this.currentUser.Title;
    }
    for (const option of this.options) {
      ListFilterService.updateOption(this._property, option);
    }
    this.setDescriptionAndTitle();
    this.eventBroker.publish('FilterPropertyChanged', {
      sender: this,
      property: this.property
    } as FilterPropertyChanged)
    this.filterChanged.emit();
    if (this.isSideBar) this.sidebar.hide();
  }

  clear(): void {
    this.isMeSelected = false;
    for (const op of this.visibleOptions) {
      op.IsChecked = false;
    }
    for (const op of this.options) {
      op.IsChecked = false;
    }
    if (!this.isSideBar) this.apply();
  }
}
